// React Dependencies
import React from 'react';

// External Dependencies
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';

// Internal Dependencies
import OverLoading from '../../global/OverLoading';
import SearchCard from '../../../pages/categoryPinnedPost/searchCard';
import SearchBar from '../../../pages/categoryPinnedPost/searchBar';

export default function PostsDialogView({
  loading, allPostCount, totalCount, pageNo, posts, postsUpdated,
  openAdd, onAdd, handleClose, setPageNo, setBrandSearch, isPinLabel,
}) {
  return (
    <Dialog fullWidth maxWidth="lg" open={openAdd} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title" style={{ paddingTop: 20, paddingLeft: 50, paddingRight: 50 }}>
        <SearchBar
          onSearch={(postBrand) => {
            setPageNo(1);
            setBrandSearch(postBrand);
          }}
          existingPinnedPost={[posts]}
          label="Search by Post Brand"
          style={{ width: '100%' }}
        />
      </DialogTitle>
      <DialogContent style={{ height: '80vh', paddingLeft: 50, paddingRight: 50 }}>
        { !loading ? (
          <div className="container">
            <div className="row">
              <SearchCard data={postsUpdated} lastIndex={posts.length} onAdd={(data) => onAdd(data)} isPinLabel={isPinLabel} />
            </div>
          </div>
        ) : <OverLoading />}
      </DialogContent>
      <DialogActions style={{ paddingTop: 20, paddingRight: 20, paddingBottom: 10 }}>
        <div className="d-block" style={{ width: '100%' }}>
          <div className="float-left">
            {totalCount > 0 && (
              <Pagination
                color="secondary"
                size="large"
                count={totalCount}
                page={pageNo}
                onChange={(event, value) => {
                  setPageNo(value);
                }}
                className="float-left"
              />
            )}
            <p style={{
              display:  'inline-block',
              margin:   '10px 0 0 30px',
              fontSize: 17,
            }}
            >
              Total count:
              {' '}
              {allPostCount}
            </p>
          </div>

          <Button onClick={handleClose} variant="contained" color="primary" className="float-right">Close</Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
